// test2156
(2156 && 0);
